import React from "react";

const Loader = ({className}) => <div className={`loader loading ${className}`}>
  <img src="/assets/images/coploading.gif" alt="loader"/>
</div>;
export default Loader;
